module.exports = __webpack_public_path__ + "img/143.a19e84b6.png";